import React, { useState } from "react";
import Row from "../layout/Row";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";

function NavBarButton({
  premium = false,
  parameter = false,
  visible = true,
  icon,
  children,
  alert = false,
  onClick,
  className,
  actualpage,
  isActualPage = false,
  squeezed = false,
}) {
  const [hover, setHover] = useState(false);

  if (!visible) return null;

  return (
    <button
      className={`w-full px-2 ${squeezed ? "py-0" : "py-1"}  rounded-md font-medium flex items-center transition-all ${
        isActualPage
          ? premium === 1
            ? "bg-purple-100 text-violet-500 border-violet-500"
            : premium === 2
              ? "bg-purple-100 text-violet-500  border-violet-500"
              : "bg-shadow_5 text-black border-shadow_50 "
          : hover
            ? premium === 1
              ? "bg-purple-50 text-violet-400  border-violet-500"
              : premium === 2
                ? "bg-purple-50 text-violet-500  border-violet-500"
                : "bg-neutral-100 text-black border-transparent "
            : "bg-transparent text-gray-500 border-transparent "
      } shadow-none hover:shadow-none border-l-2 ${className}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
    >
      <div className="flex flex-row justify-start w-full items-center relative">
        {alert && (
          <div className="absolute left-3 top-3 h-2 w-2 rounded-full bg-red-500"></div>
        )}
        <Icon1
          icon_name={icon}
          fill={
            alert
              ? "red"
              : isActualPage || hover
                ? premium
                  ? "#8b5cf6"
                  : "black"
                : "gray"
          }
        />
        <Space x={15} />
        <div
          className="text-h3  flex flex-row gap-2"
          style={{
            color:
              isActualPage || hover ? (premium ? "#8b5cf6" : "black") : "gray",
          }}
        >
          {children}
        </div>
      </div>
    </button>
  );
}

export default NavBarButton;
